const convertStatusesToCSS = (statuses) => ({
    '--statuses-error-base-default': statuses.error.base.default,
    '--statuses-error-base-action': statuses.error.base.action,
    '--statuses-error-base-active': statuses.error.base.active,
    '--statuses-error-base-active-action': statuses.error.base.activeAction,
    '--statuses-error-text-default': statuses.error.text.default,
    '--statuses-error-text-action': statuses.error.text.action,
    '--statuses-error-text-active': statuses.error.text.active,
    '--statuses-error-text-active-action': statuses.error.text.activeAction,
    '--statuses-warning-base-default': statuses.warning.base.default,
    '--statuses-warning-base-action': statuses.warning.base.action,
    '--statuses-warning-base-active': statuses.warning.base.active,
    '--statuses-warning-base-active-action': statuses.warning.base.activeAction,
    '--statuses-warning-text-default': statuses.warning.text.default,
    '--statuses-warning-text-action': statuses.warning.text.action,
    '--statuses-warning-text-active': statuses.warning.text.active,
    '--statuses-warning-text-active-action': statuses.warning.text.activeAction,
    '--statuses-success-base-default': statuses.success.base.default,
    '--statuses-success-base-action': statuses.success.base.action,
    '--statuses-success-base-active': statuses.success.base.active,
    '--statuses-success-base-active-action': statuses.success.base.activeAction,
    '--statuses-success-text-default': statuses.success.text.default,
    '--statuses-success-text-action': statuses.success.text.action,
    '--statuses-success-text-active': statuses.success.text.active,
    '--statuses-success-text-active-action': statuses.success.text.activeAction,
    '--statuses-information-base-default': statuses.information.base.default,
    '--statuses-information-base-action': statuses.information.base.action,
    '--statuses-information-base-active': statuses.information.base.active,
    '--statuses-information-base-active-action': statuses.information.base.activeAction,
    '--statuses-information-text-default': statuses.information.text.default,
    '--statuses-information-text-action': statuses.information.text.action,
    '--statuses-information-text-active': statuses.information.text.active,
    '--statuses-information-text-active-action': statuses.information.text.activeAction,
    '--statuses-positive-base-default': statuses.positive.base.default,
    '--statuses-positive-base-action': statuses.positive.base.action,
    '--statuses-positive-base-active': statuses.positive.base.active,
    '--statuses-positive-base-active-action': statuses.positive.base.activeAction,
    '--statuses-positive-text-default': statuses.positive.text.default,
    '--statuses-positive-text-action': statuses.positive.text.action,
    '--statuses-positive-text-active': statuses.positive.text.active,
    '--statuses-positive-text-active-action': statuses.positive.text.activeAction,
    '--statuses-negative-base-default': statuses.negative.base.default,
    '--statuses-negative-base-action': statuses.negative.base.action,
    '--statuses-negative-base-active': statuses.negative.base.active,
    '--statuses-negative-base-active-action': statuses.negative.base.activeAction,
    '--statuses-negative-text-default': statuses.negative.text.default,
    '--statuses-negative-text-action': statuses.negative.text.action,
    '--statuses-negative-text-active': statuses.negative.text.active,
    '--statuses-negative-text-active-action': statuses.negative.text.activeAction,
    '--statuses-highlight-base-default': statuses.highLight.base.default,
    '--statuses-highlight-base-action': statuses.highLight.base.action,
    '--statuses-highlight-base-active': statuses.highLight.base.active,
    '--statuses-highlight-base-active-action': statuses.highLight.base.activeAction,
    '--statuses-highlight-text-default': statuses.highLight.text.default,
    '--statuses-highlight-text-action': statuses.highLight.text.action,
    '--statuses-highlight-text-active': statuses.highLight.text.active,
    '--statuses-highlight-text-active-action': statuses.highLight.text.activeAction,
    '--statuses-disabled': statuses.disabled.toString(),
});
const convertStatusesToObject = (statuses) => ({
    statusesErrorBaseDefault: statuses.error.base.default,
    statusesErrorBaseAction: statuses.error.base.action,
    statusesErrorBaseActive: statuses.error.base.active,
    statusesErrorBaseActiveAction: statuses.error.base.activeAction,
    statusesErrorTextDefault: statuses.error.text.default,
    statusesErrorTextAction: statuses.error.text.action,
    statusesErrorTextActive: statuses.error.text.active,
    statusesErrorTextActiveAction: statuses.error.text.activeAction,
    statusesWarningBaseDefault: statuses.warning.base.default,
    statusesWarningBaseAction: statuses.warning.base.action,
    statusesWarningBaseActive: statuses.warning.base.active,
    statusesWarningBaseActiveAction: statuses.warning.base.activeAction,
    statusesWarningTextDefault: statuses.warning.text.default,
    statusesWarningTextAction: statuses.warning.text.action,
    statusesWarningTextActive: statuses.warning.text.active,
    statusesWarningTextActiveAction: statuses.warning.text.activeAction,
    statusesSuccessBaseDefault: statuses.success.base.default,
    statusesSuccessBaseAction: statuses.success.base.action,
    statusesSuccessBaseActive: statuses.success.base.active,
    statusesSuccessBaseActiveAction: statuses.success.base.activeAction,
    statusesSuccessTextDefault: statuses.success.text.default,
    statusesSuccessTextAction: statuses.success.text.action,
    statusesSuccessTextActive: statuses.success.text.active,
    statusesSuccessTextActiveAction: statuses.success.text.activeAction,
    statusesInformationBaseDefault: statuses.information.base.default,
    statusesInformationBaseAction: statuses.information.base.action,
    statusesInformationBaseActive: statuses.information.base.active,
    statusesInformationBaseActiveAction: statuses.information.base.activeAction,
    statusesInformationTextDefault: statuses.information.text.default,
    statusesInformationTextAction: statuses.information.text.action,
    statusesInformationTextActive: statuses.information.text.active,
    statusesInformationTextActiveAction: statuses.information.text.activeAction,
    statusesPositiveBaseDefault: statuses.positive.base.default,
    statusesPositiveBaseAction: statuses.positive.base.action,
    statusesPositiveBaseActive: statuses.positive.base.active,
    statusesPositiveBaseActiveAction: statuses.positive.base.activeAction,
    statusesPositiveTextDefault: statuses.positive.text.default,
    statusesPositiveTextAction: statuses.positive.text.action,
    statusesPositiveTextActive: statuses.positive.text.active,
    statusesPositiveTextActiveAction: statuses.positive.text.activeAction,
    statusesNegativeBaseDefault: statuses.negative.base.default,
    statusesNegativeBaseAction: statuses.negative.base.action,
    statusesNegativeBaseActive: statuses.negative.base.active,
    statusesNegativeBaseActiveAction: statuses.negative.base.activeAction,
    statusesNegativeTextDefault: statuses.negative.text.default,
    statusesNegativeTextAction: statuses.negative.text.action,
    statusesNegativeTextActive: statuses.negative.text.active,
    statusesNegativeTextActiveAction: statuses.negative.text.activeAction,
    statusesHighLightBaseDefault: statuses.highLight.base.default,
    statusesHighLightBaseAction: statuses.highLight.base.action,
    statusesHighLightBaseActive: statuses.highLight.base.active,
    statusesHighLightBaseActiveAction: statuses.highLight.base.activeAction,
    statusesHighLightTextDefault: statuses.highLight.text.default,
    statusesHighLightTextAction: statuses.highLight.text.action,
    statusesHighLightTextActive: statuses.highLight.text.active,
    statusesHighLightTextActiveAction: statuses.highLight.text.activeAction,
    statusesDisabled: statuses.disabled.toString(),
});
const Statuses = {
    error: {
        base: {
            default: 'var(--statuses-error-base-default)',
            action: 'var(--statuses-error-base-action)',
            active: 'var(--statuses-error-base-active)',
            activeAction: 'var(--statuses-error-base-active-action)',
        },
        text: {
            default: 'var(--statuses-error-text-default)',
            action: 'var(--statuses-error-text-action)',
            active: 'var(--statuses-error-text-active)',
            activeAction: 'var(--statuses-error-text-active-action)',
        },
    },
    warning: {
        base: {
            default: 'var(--statuses-warning-base-default)',
            action: 'var(--statuses-warning-base-action)',
            active: 'var(--statuses-warning-base-active)',
            activeAction: 'var(--statuses-warning-base-active-action)',
        },
        text: {
            default: 'var(--statuses-warning-text-default)',
            action: 'var(--statuses-warning-text-action)',
            active: 'var(--statuses-warning-text-active)',
            activeAction: 'var(--statuses-warning-text-active-action)',
        },
    },
    success: {
        base: {
            default: 'var(--statuses-success-base-default)',
            action: 'var(--statuses-success-base-action)',
            active: 'var(--statuses-success-base-active)',
            activeAction: 'var(--statuses-success-base-active-action)',
        },
        text: {
            default: 'var(--statuses-success-text-default)',
            action: 'var(--statuses-success-text-action)',
            active: 'var(--statuses-success-text-active)',
            activeAction: 'var(--statuses-success-text-active-action)',
        },
    },
    information: {
        base: {
            default: 'var(--statuses-information-base-default)',
            action: 'var(--statuses-information-base-action)',
            active: 'var(--statuses-information-base-active)',
            activeAction: 'var(--statuses-information-base-active-action)',
        },
        text: {
            default: 'var(--statuses-information-text-default)',
            action: 'var(--statuses-information-text-action)',
            active: 'var(--statuses-information-text-active)',
            activeAction: 'var(--statuses-information-text-active-action)',
        },
    },
    positive: {
        base: {
            default: 'var(--statuses-positive-base-default)',
            action: 'var(--statuses-positive-base-action)',
            active: 'var(--statuses-positive-base-active)',
            activeAction: 'var(--statuses-positive-base-active-action)',
        },
        text: {
            default: 'var(--statuses-positive-text-default)',
            action: 'var(--statuses-positive-text-action)',
            active: 'var(--statuses-positive-text-active)',
            activeAction: 'var(--statuses-positive-text-active-action)',
        },
    },
    negative: {
        base: {
            default: 'var(--statuses-negative-base-default)',
            action: 'var(--statuses-negative-base-action)',
            active: 'var(--statuses-negative-base-active)',
            activeAction: 'var(--statuses-negative-base-active-action)',
        },
        text: {
            default: 'var(--statuses-negative-text-default)',
            action: 'var(--statuses-negative-text-action)',
            active: 'var(--statuses-negative-text-active)',
            activeAction: 'var(--statuses-negative-text-active-action)',
        },
    },
    highLight: {
        base: {
            default: 'var(--statuses-highlight-base-default)',
            action: 'var(--statuses-highlight-base-action)',
            active: 'var(--statuses-highlight-base-active)',
            activeAction: 'var(--statuses-highlight-base-active-action)',
        },
        text: {
            default: 'var(--statuses-highlight-text-default)',
            action: 'var(--statuses-highlight-text-action)',
            active: 'var(--statuses-highlight-text-active)',
            activeAction: 'var(--statuses-highlight-text-active-action)',
        },
    },
    disabled: 'var(--statuses-disabled)',
};

export { Statuses, convertStatusesToCSS, convertStatusesToObject };
